import { nanoid } from "nanoid";

export default function neurodynamicsSlice(set, get) {
  return {
    // The store keeps an array of experiments.
    // We define actions for add/remove/modify an experiment:

    addNeurodynamicsExperiment: (sourceExpId) => {
      // copy the state from an existing experiment:
      const state = get();
      const experimentsArr = state.neurodynamicsExperimentsArr;
      const currentCounter = state.neurodynamicsExpCounter;

      // Find existing experiment to clone
      const sourceExp = experimentsArr.find((exp) => exp.id === sourceExpId);

      // Generate new ID
      const newExpId = `neurodynamicsExp-${nanoid(4)}`;
      // Clone the experiment
      const newExp = {
        ...sourceExp,
        id: newExpId,
        displayNumber: currentCounter,
      };

      // Insert into array with new ID
      set((prev) => ({
        neurodynamicsExperimentsArr: [
          ...prev.neurodynamicsExperimentsArr,
          newExp,
        ],
        neurodynamicsExpCounter: prev.neurodynamicsExpCounter + 1,
      }));

      // Return the new ID so the UI can switch to it
      return newExpId;
    },

    removeNeurodynamicsExperiment: (id) => {
      set((prev) => ({
        neurodynamicsExperimentsArr: prev.neurodynamicsExperimentsArr.filter(
          (exp) => exp.id !== id
        ),
        // Counter does NOT decrease here
      }));
    },

    setNeurodynamicsValues: (id, property, value) => {
      set((prev) => ({
        neurodynamicsExperimentsArr: prev.neurodynamicsExperimentsArr.map(
          (exp) => (exp.id === id ? { ...exp, [property]: value } : exp)
        ),
      }));
    },
  };
}
